export type EcommerceItem = {
  name: string;
  sku: string;
  price: number;
  quantity: number;
  category?: string;
};

export enum ChargeToretaLabel {
  QuickChargeFromCredit = 'quickChargeFromCredit', // クイックチャージ（クレジットカード）
  QuickChargeFromWallet = 'quickChargeFromWallet', // クイックチャージ（入金/払戻金）
  PreChargeFromCredit = 'preChargeFromCredit', // その場でチャージ（クレジットカード）
  PreChargeFromWallet = 'preChargeFromWallet', // その場でチャージ（入金/払戻金）
}

export const PremiumBannerContentsID = 'hhgno74k84t1';

export enum BannerAreaLabel {
  MainVisual = 'banner', // 上部：ローテーションバナー
  TopBanner = 'rightside_banner', // 中段：メインバナー
  MiddleBanner = 'footer_banner', // 下段：フッターバナーの上部
  FooterBanner = 'footer_banner', // 下段：フッターバナーの下部
}
